import React, { useState } from "react";
import { Grid } from "@mui/material";
import { BlockDataGrid } from "../../Common/BlockDataGrid";
import {
  Accordion, AccordionSummary, AccordionDetails, Typography,
  Box, TextField, Button
} from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

import { CallPredict } from '../../../api/LVCCApi';

const DualWavelengthBlank = () => {
  const [gridData, setGridData] = useState([]);
  const [spline1GridData, setSpline1GridData] = useState([]);
  const [spline2GridData, setSpline2GridData] = useState([]);

  const [response, setResponse] = useState("{}");

  const [parameters, setParameters] = useState({
    assayNumber: "300",
    fKExponent: 2.0,
    intercept: 0,
    slope: 0,
    curvature: 0
  });

  const handleGridDataChange = (newData) => {
    setGridData(newData);
  };

  const handleSpline1GridDataChange = (newData) => {
    setSpline1GridData(newData);
  };

  const handleSpline2GridDataChange = (newData) => {
    setSpline2GridData(newData);
  };

  const handleCalculate = () => {
    const getColumnValues = (gridData, columnKey) => {
      return columnKey ? gridData
        .map(row => parseFloat(row[columnKey]))
        .filter(val => !isNaN(val)) : [];
    };

    const apiPayload = {
      assayNumber: parameters.assayNumber,
      dResponse1: getColumnValues(gridData, "Response 1"),
      dResponse2: getColumnValues(gridData, "Response 2"),
      parameters: {
        intercept: parameters.intercept,
        slope: parameters.slope,
        curvature: parameters.curvature
      },
      genInfo: {
        lAssayNumber: parameters.assayNumber,
        fKExponent: parameters.fKExponent
      },
      spline: {
        xG1Spline: {
          sSplineNodeCount: getColumnValues(spline1GridData, "X").length,
          afX: getColumnValues(spline1GridData, "X"),
          afY1: getColumnValues(spline1GridData, "Y"),
          afY2: getColumnValues(spline1GridData, "Y2")
        },
        xG2Spline: {
          sSplineNodeCount: getColumnValues(spline2GridData, "X").length,
          afX: getColumnValues(spline2GridData, "X"),
          afY1: getColumnValues(spline2GridData, "Y"),
          afY2: getColumnValues(spline2GridData, "Y2")
        }
      },
    };

    console.log("API Call Payload:", JSON.stringify(apiPayload, null, 2));
    CallPredict.DMB(apiPayload).then((r) => {
      console.log(r);
      setResponse(JSON.stringify(r.data));
    });
  };

  return (
    <div>
      <Typography variant="h6">Data</Typography>
      <p>Type or paste data into the below components</p>

      <Grid direction='row' container spacing={1}>
        <Grid container item sm={6}>
          <BlockDataGrid
            onDataChange={handleGridDataChange}
            columnNames={["Response 1", "Response 2"]}
          />
        </Grid>
        <Grid container item sm={6}>
          <div style={{ width: '100%' }}>
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>Spline 1</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <BlockDataGrid
                  onDataChange={handleSpline1GridDataChange}
                  columnNames={["X", "Y", "Y2"]}
                />
              </AccordionDetails>
            </Accordion>
            <Accordion>
              <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                <Typography>Spline 2</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <BlockDataGrid
                  onDataChange={handleSpline2GridDataChange}
                  columnNames={["X", "Y", "Y2"]}
                />
              </AccordionDetails>
            </Accordion>
          </div>
        </Grid>
      </Grid>

      <Typography variant="h6" sx={{ mb: 1, pt: 2 }}>Parameters</Typography>
      <Box
        className="param"
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)",
          gap: 2
        }}
      >
        {Object.entries(parameters).map(([key, value]) => (
          <Box key={key} sx={{ display: "flex", flexDirection: "column", gap: "4px" }}>
            <Typography variant="caption" sx={{ fontWeight: "bold", color: "gray" }}>
              {key}
            </Typography>
            <TextField
              type="number"
              value={value}
              onChange={(e) => setParameters({ ...parameters, [key]: e.target.value })}
              fullWidth
              variant="outlined"
              size="small"
            />
          </Box>))}
      </Box>

      <Box sx={{ display: "flex", justifyContent: "right", mb: 3, pr: 5 }}>
        <Button variant="contained" color="primary" size="large" onClick={handleCalculate}>Calculate</Button>
      </Box>

      <Typography variant="h6">Output</Typography>
      <TextField multiline rows={6} value={response} fullWidth margin="dense" />

    </div>
  )
}

export default DualWavelengthBlank; 